import { ChevronDown } from "lucide-react";
import { DMSStatus } from "@/components/UI";
import { api } from "@/lib/api";
import { useToast } from "@/lib/toast";

const STATUSES = {
  quotation: ["draft", "issued", "sent", "accepted", "rejected", "cancelled", "completed"],
  invoice: ["draft", "issued", "sent", "accepted", "cancelled", "completed"],
  job_card: ["draft", "issued", "sent", "completed", "cancelled"],
  sdn: ["draft", "issued", "sent", "completed", "cancelled"],
};

// Status badge with an invisible native <select> overlay — click the badge to
// change status (native dropdown is never clipped by table overflow).
export const StatusMenu = ({ doc, onChanged }) => {
  const { toast } = useToast();
  const setStatus = async (s) => {
    if (!s || s === doc.status) return;
    try {
      await api.updateDmsDoc(doc.id, { status: s });
      toast(`${doc.serial} marked ${s}`, "success");
      onChanged?.();
    } catch (e) {
      toast(e?.response?.data?.detail || "Status update failed", "error");
    }
  };
  const list = STATUSES[doc.doc_type] || STATUSES.quotation;
  return (
    <div
      className="relative inline-flex items-center gap-0.5 cursor-pointer"
      data-testid={`status-menu-${doc.id}`}
      onClick={(e) => e.stopPropagation()}
      title="Change status"
    >
      <DMSStatus status={doc.status} />
      <ChevronDown size={12} className="text-slate-400" />
      <select
        data-testid={`status-select-${doc.id}`}
        className="absolute inset-0 opacity-0 cursor-pointer"
        value={doc.status}
        onChange={(e) => setStatus(e.target.value)}
        onClick={(e) => e.stopPropagation()}
      >
        {list.map((s) => (
          <option key={s} value={s}>{s.charAt(0).toUpperCase() + s.slice(1)}</option>
        ))}
      </select>
    </div>
  );
};
